import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Currency, CurrenciesData} from "@core/services/backend/common/interface/currencies";
import {CurrenciesApi} from "@core/services/backend/common/api/currencies.api";

@Injectable()
export class CurrenciesService extends CurrenciesData {
    constructor(private api: CurrenciesApi) {
        super();
    }

    list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any[]> {
        return this.api.list(search, pageNumber, pageSize, orderBy);
    }

    get(id: number): Observable<Currency> {
        return this.api.get(id);
    }

    create(currency: any): Observable<Currency> {
        return this.api.add(currency);
    }

    update(currency: any): Observable<Currency> {
        return this.api.update(currency);
    }

    delete(currency: any): Observable<Currency> {
        return this.api.delete(currency);
    }
}

